import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthService } from './auth.service';
import { AuthUsersGuard } from './auth-guard.service';
import { UnauthorizedPageComponent } from './views/unautorized-component/unauthorised-page.component';

const routes: Routes = [
  {
    path: 'test-plans',
    canActivate : [AuthUsersGuard],
    loadChildren: () => import('./views/test-plans/test-plans.module').then(m => m.TestPlansModule)
  },
  {
    path: 'authorized',
    component : UnauthorizedPageComponent
  },
  {
    path: '',
    redirectTo: '/test-plans',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
  ],
  exports: [RouterModule],
  providers: [AuthService, AuthUsersGuard]
})
export class RoutingModule { }
